import React, {useState, useEffect, useContext} from 'react';
import { Alert } from 'react-bootstrap';
import { Col, Row, Card, Form, Button } from 'react-bootstrap';
import axios from "axios";
import { fetchAuthSession, getCurrentUser, signOut, signIn } from '@aws-amplify/auth';
import Preloader from "../../components/Preloader/Preloader";
import { ProductContext } from '../../ProductProvider';

const config = require('../../config.json');
const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default function EmailUpdateModal(props) {
    const { alertClose, alertDetails, setAlertDetails, loggedUser, generateDate } = useContext(ProductContext);
    const {selectedRegistrationNo, selectedEmail, fetchCurrentYearDetails, emailToggle} = props;
    const [newEmail, setNewEmail] =useState('');
    const [loaded, setLoaded]=useState(false);

    useEffect(() => {
        //console.log("Props : " , props);
        if(selectedRegistrationNo){
        setLoaded(true);
    }
    }, [selectedEmail, selectedRegistrationNo])
   
    const handleEmailChange =async(event)=>{
        event.preventDefault();
        try{
            if(newEmail===""){
                setAlertDetails({
                    ...alertDetails,
                    style:"warning",
                    open:true,
                    message:"New Email Address Cannot be Empty"
                });  
            }else if(!newEmail.match(validRegex)){
                setAlertDetails({
                  ...alertDetails,
                  style:"warning",
                  open:true,
                  message: "Email address is not in right format!"
              }); 
              }else{
            setLoaded(false);
            const todayDate=await generateDate();
const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const params={
                registrationNo: selectedRegistrationNo, 
                oldemail:selectedEmail, 
                newemail:newEmail, 
                updatedBy:loggedUser.nickname, 
                updatedOn:todayDate
            };
            //console.log("Params : ", params); 
            await axios.patch(`${config.api.invokeURL}/dashboard/accounts/emailid`, params, {
                headers: {
                  Authorization: idToken,
                  'x-api-key':config.api.key
                }
              }).then(async(res)=>{
                await fetchCurrentYearDetails();
                emailToggle();      
                  setAlertDetails({
                    ...alertDetails,
                    style:"success",
                    open:true,
                    message:"Email Successfully Updated"
                });    
                }).catch((error)=>{
                    setAlertDetails({
                        ...alertDetails,
                        style:"warning",
                        open:true,
                        message:"Error Occured - " + error.message
                    });     
                    setLoaded(true);   
                })
            }
        }catch(error){
            setAlertDetails({
                ...alertDetails,
                style:"warning",
                open:true,
                message:"Error Occured - " + error.message
            });  
            setLoaded(true);              
        }
        setLoaded(true);
    }


  return (
    <>
    <Preloader show={loaded ? false : true} />
    <Alert color={alertDetails.style} isOpen={alertDetails.open} toggle={alertClose} >
        {alertDetails.message}
      </Alert>
    <Card border="light" className=" bg-white shadow-sm mb-4">
       <Card.Body>     
         <Form>
         <Row>
         <Form.Group id="currentEmail">
         <Form.Label>Current Email Address</Form.Label>
        <Form.Control type="text" value={selectedEmail}
            disabled />
            </Form.Group>
         </Row>
         <Row>
         <Form.Group id="newEmail">
        <Form.Label>New Email Address</Form.Label>
        <Form.Control type="text" name="newEmail"
        value={newEmail} onChange={(event)=>{setNewEmail(event.target.value)}}/>
        </Form.Group>
         </Row>
         <div className="mt-3 text-center">
             <Button variant="primary" type="submit" onClick={(event)=>{handleEmailChange(event)}}>Update</Button>
           </div>

         </Form>
         </Card.Body>     

    </Card>
    </>
  )
}

